import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class StaffAttendanceService {
  private baseUrl = environment.apiUrl;

  constructor(private http: HttpClient) {}

  clockIn(staffId: number, merchantId: number, clockInMethod: string = 'LIST'): Observable<any> {
    return this.http.post(`${this.baseUrl}/api/staffAttendance/clockIn`, {
      clockInRequest: { staffId, merchantId, clockInMethod }
    });
  }

  clockOut(staffAttendanceId: number, clockOutMethod: string = 'LIST'): Observable<any> {
    return this.http.post(`${this.baseUrl}/api/staffAttendance/clockOut`, {
      clockOutRequest: { staffAttendanceId, clockOutMethod }
    });
  }

  clockInByNfc(nfcCardId: string, merchantId: number): Observable<any> {
    return this.http.post(`${this.baseUrl}/api/staffAttendance/clockInByNfc`, {
      nfcRequest: { nfcCardId, merchantId }
    });
  }

  clockOutByNfc(nfcCardId: string, merchantId: number): Observable<any> {
    return this.http.post(`${this.baseUrl}/api/staffAttendance/clockOutByNfc`, {
      nfcRequest: { nfcCardId, merchantId }
    });
  }

  getCurrentlyWorking(merchantId: number): Observable<any[]> {
    return this.http.post<any[]>(`${this.baseUrl}/api/staffAttendance/getCurrentlyWorking`, {
      merchantId
    });
  }

  getAttendanceHistory(merchantId: number, startDate: string, endDate: string): Observable<any> {
    return this.http.post<any>(`${this.baseUrl}/api/staffAttendance/getAttendanceReport`, {
      merchantId,
      staffId: null,
      startDate: startDate + 'T00:00:00',
      endDate: endDate + 'T23:59:59',
      pageRequest: { page: 0, size: 50 }
    });
  }

  getAllStaff(merchantId: number): Observable<any> {
    return this.http.post<any>(`${this.baseUrl}/api/staffProfile/getPagedStaffProfile`, {
      merchantId,
      pageRequest: { page: 0, size: 999 }
    });
  }

  getSettings(merchantId: number): Observable<any> {
    return this.http.post<any>(`${this.baseUrl}/api/staffAttendanceSettings/getSettings`, {
      merchantId
    });
  }
}
